import * as React from "react";
import { Field, Select } from "@grandvisionhq/forms";
/* empty css               */
const TopicList = ({
  errorMessage,
  label,
  placeholder,
  required,
  validations,
  "data-t": testId = "topic-list",
  options
}) => {
  return /* @__PURE__ */ React.createElement(
    Field,
    {
      name: "topic-list",
      label,
      error: errorMessage,
      validations,
      required,
      placeholder,
      className: "topic-list"
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        id: "topic-list-select",
        name: "topic-list-select",
        options,
        required,
        placeholder: "placeholder",
        "data-t": testId
      }
    )
  );
};
export {
  TopicList as default
};
//# sourceMappingURL=TopicList.js.map
